export default __webpack_public_path__ + "static/media/2.c95eefb1.jpg";